import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import SeoManager from "@/seo/SeoManager";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Search from "@/pages/Search";
import ProProfile from "@/pages/ProProfile";
import Dashboard from "@/pages/Dashboard";
import Messages from "@/pages/Messages";
import Upgrade from "@/pages/Upgrade";
import Admin from "@/pages/Admin";
import ResetPassword, { ForgotPassword } from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import MyBoard from "@/pages/MyBoard";
import SharedBoard from "@/pages/SharedBoard";
import Contact from "@/pages/Contact";
import Feedback from "@/pages/Feedback";
import Feed from "@/pages/Feed";
import RequestDetail from "@/pages/RequestDetail";
import Following from "@/pages/Following";
import Settings from "@/pages/Settings";
import ClientProfile from "@/pages/ClientProfile";
import MyActivity from "@/pages/MyActivity";
import FAQ from "@/pages/FAQ";
import Learn from "@/pages/Learn";
import Legal from "@/pages/Legal";
import LegalDoc from "@/pages/LegalDoc";
import ProTerms from "@/pages/ProTerms";
import Connections from "@/pages/Connections";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <SeoManager />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/search" element={<Search />} />
            <Route path="/pro/:id" element={<ProProfile />} />
            <Route path="/pro/:id/:section" element={<ProProfile />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/upgrade" element={<Upgrade />} />
            <Route path="/upgrade/success" element={<Upgrade />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/board" element={<MyBoard />} />
            <Route path="/board/share/:token" element={<SharedBoard />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/feed" element={<Feed />} />
            <Route path="/wall" element={<Feed />} />
            <Route path="/requests" element={<Feed />} />
            <Route path="/requests/:id" element={<RequestDetail />} />
            <Route path="/following" element={<Following />} />
            <Route path="/client/:id" element={<ClientProfile />} />
            <Route path="/my-activity" element={<MyActivity />} />
            <Route path="/activity" element={<MyActivity />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/learn" element={<Learn />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/legal/pro-terms" element={<ProTerms />} />
            <Route path="/legal/:slug" element={<LegalDoc />} />
            <Route path="/connections" element={<Connections />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
